<script setup lang="ts">
import { computed } from 'vue';
import { Checkbox } from '@/components/ui/checkbox';

const props = defineProps<{
    param: string;
    value: string;
}>();

const url = new URL(window.location.href);
const key = `${props.param}[]`;

const isActive = computed(() =>
    url.searchParams.getAll(key).includes(props.value)
);

function onUpdate(checked: boolean | 'indeterminate') {
    const url = new URL(window.location.href);
    const values = url.searchParams
        .getAll(key)
        .filter((v) => v !== props.value);

    if (checked) values.push(props.value);

    url.searchParams.delete(key);
    values.forEach((v) => url.searchParams.append(key, v));
    window.location.href = url.toString();
}
</script>

<template>
    <Checkbox
        :model-value="isActive"
        @update:model-value="onUpdate"
    />
</template>
